import {Delivery, DeliveryState, getOccupancyDeliveries, Tenant, TenantUser} from "./types";
import {Occupancy} from "@variocube/app-api";
import {useStorageItemValue} from "@variocube/cube-ui";
import {useCallback, useMemo} from "react";
import {logger} from "./logger";
import {useLocalization} from "../i18n";


export function getDeliveryStateName(state: DeliveryState) {
    const {t} = useLocalization();
    switch (state) {
        case DeliveryState.Created:
            return t("Created");
        case DeliveryState.Reserved:
            return t("Reserved");
        case DeliveryState.Stored:
            return t("Stored");
        case DeliveryState.Returned:
            return t("Returned");
        case DeliveryState.Cancelled:
            return t("Cancelled");
        case DeliveryState.PickedUp:
            return t("PickedUp");
    }
}

export function findDeliveryOccupancies(occupancy: Occupancy[], delivery: Delivery) {
    return occupancy.filter(occupancy => {
        const deliveries = getOccupancyDeliveries(occupancy);
        return deliveries?.find(occupancyDelivery => occupancyDelivery.delivery.deliveryId == delivery.delivery.deliveryId);
    });
}

export type UserAction = "mark-checked";

export function useStoreUserAction() {
    const log = useMemo(() => logger.sub("storeUserAction"), []);
    const tenant = useStorageItemValue<Tenant>("tenant");
    const baseUrl = useStorageItemValue<string>("backendUrl");

    return useCallback(async (delivery: Delivery, user: TenantUser, action: UserAction) => {
        if (tenant) {
            const url = `${baseUrl}public/tenants/${tenant.centerId}/deliveries/${delivery.delivery.deliveryId}/${action}`;
            try {
                log.info("Storing user action", {url, user});
                const response = await window.fetch(url, {
                    method: "POST",
                    body: JSON.stringify({
                        username: user.username
                    }),
                    headers: {"Content-type": "application/json"}
                });
                if (!response.ok) {
                    log.error("Failed to save user action", response.status);
                }
            }
            catch (error) {
                log.error("Failed to save user action", error);
            }
        }
    }, [tenant, baseUrl]);
}

export function shortenUuid(uuid: string) {
    if(uuid.length == 36) {
        return uuid.substring(0, 4) + "..." + uuid.substring(32, 36);
    }
    return uuid;
}

